export { default } from 'containers/CaseStudyPage/CaseStudyPage';
export {
  getStaticPaths,
  getStaticProps,
} from 'containers/CaseStudyPage/CaseStudyPage.data';
